import Vue from 'vue'
import './plugins/element-ui'
import { registerMicroApps, start, addGlobalUncaughtErrorHandler } from 'qiankun'
import store from '@/store/index.js'
import router from '@/router'
import api from '@/api/api'
import $bus from './bus'
import App from '@/App.vue'
import '@/assets/styles/global.scss'
import { getAppsPermission, routerPermission } from './utils/util'
import 'animate.css'

Vue.prototype.$api = api

let vm = null
function render() {
  vm = new Vue({
    router,
    store,
    provide: { $bus },
    render: (h) => h(App)
  }).$mount('#main--app-container')
  return vm
}

// 注册与启动子应用、错误监听
function runSubApps(registerApps) {
  return () => {
    // 注册
    registerMicroApps(registerApps, {
      beforeLoad() {
        $bus.$emit('loading', true)
      },
      afterMount() {
        $bus.$emit('loading', false)
      }
    })
    // 启动
    start({ prefetch: false })
    // 错误监听
    addGlobalUncaughtErrorHandler((event) => {
      let { message } = event
      if (message?.includes('Failed to fetch')) {
        $bus.$emit('loading', false)
        console.warn(event)
        vm.$message.error('应用加载失败')
      }
    })
  }
}

// 白名单页面不校验权限
const routerWhiteList = ['/login', '/error']
const paths = location.pathname.match(/\/\w+/)
if (Array.isArray(paths) && routerWhiteList.includes(paths[0])) {
  render()
} else {
  getAppsPermission()
    .then((registerApps) => {
      // 登录后跳 /home 页
      router.addRoute({ path: '/', redirect: '/home' })
      routerPermission(registerApps) // 权限路由拦截
      $bus.$once('main-app-load', runSubApps(registerApps))
      render() // 渲染主应用
    })
}
